export const menuNameKeyMap: Record<string, string> = {
  Dashboard: 'dashboard',
  'Balance Sheet': 'balanceSheet',
  Portfolio: 'portfolio',
  'Client Services': 'clientServices',
  Clients: 'clients',
  Relationships: 'relationships',
  Prospects: 'prospects',
  'Activity & Usage': 'activityUsage',
  Accounts: 'accounts',
  Holdings: 'holdings',
  'Asset Allocation': 'configuration.terms.assetAllocation',
  'Investment Activity': 'investmentActivity.title',
  'Trading Activity': 'configuration.terms.tradingActivity',
  'Gains & Losses': 'gainsLosses',
  'Market Pricing': 'marketPricing',
  Performance: 'performance',
  "Client's Wealth": 'clientsWealth',
  'Cash Flow': 'configuration.terms.cashFlow',
  Tools: 'tools',
  'Document Vault': 'documentVault.title',
  Documents: 'documents.title',
  'Communication Directory': 'communicationDirectory',
  Notes: 'notes',
  'My Financial Team': 'myFinancialTeam.title',
  Reports: 'reports',
  'Individual Client Reports': 'individualClientReports',
  'All Client Reports': 'allClientReports',
  'Scheduled Client Reports': 'scheduledClientReports',
  'Manage Accounts': 'manageAccounts',
  'Shared Account Access': 'sharedAccountAccess',
  'Business Intelligence': 'businessIntelligence',
  Overview: 'overview',
  Opportunities: 'opportunities',
  Risks: 'risks',
  'To-Do List': 'toDoList',
  Setup: 'setup',
  'Client Portal Configuration': 'clientPortalConfiguration',
  'Client Portal': 'clientPortal',
  'Managed Accounts': 'managedAccounts',
  'Account Tags': 'accountTags',
  'Asset Classifications': 'assetClassifications',
  'Managed Assets/Non-Managed External Accounts':
    'managedAssetsNonManagedExternalAccounts',
  Integrations: 'integrations.title',
  Legal: 'legal.title',
  Terms: 'configuration.terms.title',
  AUM: 'localizationDefaults.aum',
  HeldAway: 'localizationDefaults.heldAway',
  'AUM & Held Away': 'localizationDefaults.aumAndHeldAway',
  Advisors: 'advisors',
  Advisor: 'localizationDefaults.advisor',
  'Team Members': 'teamMembers',
  TeamMembers: 'teamMembers',
  TeamMember: 'localizationDefaults.teamMember',
  'Contact Information': 'contactInformation',
  'Asset Allocation Settings': 'assetAllocationSettings',
  'Balance Sheet Categories': 'balanceSheetCategories',
  'Quick Links': 'quickLinks',
  'Vault Categories': 'vaultCategories',
};
